export enum CardiovascularRiskEnum {
  VERY_SLIGHT = 'VERY_SLIGHT',
  MILD = 'MILD',
  MODERATE = 'MODERATE',
  HIGH = 'HIGH',
  VERY_HIGH = 'VERY_HIGH',
}